const variationSync = {
  success: {
    sync_status: "Sincronizado",
    sync_error_message: {
      errors: []
    }
  },
  incomplete: {
    sync_status: "Incompleto",
    sync_error_message: {
      errors: [
        {
          level: "property",
          code: "PROP_MISSING_PHOTO",
          message: "La propiedad no tiene al menos 1 foto"
        },
        {
          level: "agent",
          code: "AGENT_MISSING_LAST_NAME",
          message: "El agente no tiene apellidos"
        }
      ]
    }
  },
  failed: {
    sync_status: "Fallido",
    sync_error_message: {
      errors: []
    }
  }
};

const getRandomSync = () => {
  const keys = Object.keys(variationSync);
  const randomKey = keys[Math.floor(Math.random() * keys.length)];
  return variationSync[randomKey as keyof typeof variationSync];
};

export const remaxGlobalDetailMock = (responseData: any) => {
  return {
    ...responseData
    // ...getRandomSync()
  };
};

export const remaxGlobalListMock = (responseDataList: any[]) => {
  return responseDataList.map(item => remaxGlobalDetailMock(item));
};
